import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";

function formatErr(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function Login() {
  const { login, register } = useAuth();
  const navigate = useNavigate();
  const [mode, setMode] = useState("login"); // login | register
  const [name, setName] = useState("");
  const [email, setEmail] = useState("drpriyankpareek@gmail.com");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const isRegister = mode === "register";

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      if (isRegister) {
        await register(email, password, name);
      } else {
        await login(email, password);
      }
      navigate("/");
    } catch (err) {
      setError(formatErr(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  const switchMode = () => {
    setError("");
    setPassword("");
    if (mode === "login") setEmail("");
    else setEmail("drpriyankpareek@gmail.com");
    setMode(isRegister ? "login" : "register");
  };

  return (
    <div className="min-h-screen flex items-center justify-center app-canvas p-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-[0_20px_60px_-15px_rgba(0,0,0,0.15)] ring-1 ring-black/5 p-8">
        <div className="flex flex-col items-center mb-6">
          <div className="rounded-2xl bg-[#0f172a] px-6 py-4 mb-3 w-full flex justify-center">
            <img src="/lucid-logo-white.webp" alt="LUCID DENTAL" className="h-14 w-auto object-contain" data-testid="login-logo" />
          </div>
          <p className="text-sm text-slate-500 mt-1">
            {isRegister ? "Create your doctor account" : "Prescription Writer — Doctor Login"}
          </p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          {isRegister && (
            <div>
              <Label htmlFor="name">Full name</Label>
              <Input id="name" type="text" value={name} onChange={(e) => setName(e.target.value)}
                placeholder="Dr. Full Name" data-testid="register-name" className="mt-1" />
            </div>
          )}
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email" className="mt-1" required />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              placeholder={isRegister ? "At least 6 characters" : ""}
              data-testid="login-password" className="mt-1" required />
          </div>
          {error && <div className="text-sm text-red-600" data-testid="login-error">{error}</div>}
          <Button type="submit" disabled={loading} data-testid={isRegister ? "register-submit" : "login-submit"}
            className="w-full bg-[#0284c7] hover:bg-[#0369a1] text-white">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : isRegister ? "Create account" : "Sign in"}
          </Button>
        </form>
        <div className="text-center text-sm text-slate-500 mt-5">
          {isRegister ? "Already have an account?" : "New here?"}{" "}
          <button type="button" onClick={switchMode} data-testid="toggle-auth-mode"
            className="text-[#0284c7] font-semibold hover:underline">
            {isRegister ? "Sign in" : "Create an account"}
          </button>
        </div>
      </div>
    </div>
  );
}
